import { AUTHORITY, PAGE_NAME } from '@/enums'
import { RouteRecordRaw } from 'vue-router'

export const getRouteRaw = (
  name: PAGE_NAME,
  path: string,
  opt?: Omit<RouteRecordRaw, 'name' | 'path'> & {
    authority?: (e: AUTHORITY) => boolean
    query?: string[]
  }
) => {
  const meta = {
    authority: opt?.authority,
    ...opt?.meta,
  }
  return {
    ...opt,
    name,
    path,
    meta,
  } as RouteRecordRaw
}
